import { Stack, Typography } from "@mui/material";
import lockSvg from "assets/Lock.svg";
import ButtonMAS from "ButtonMAS/ButtonMAS";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import c from "lib/style/colorVar.scss";

const PAGE_LOCALE_KEY = "page.tokenExpired.";

const TokenExpired = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
      direction="column"
      alignItems="center"
      textAlign="center"
      gap="8px"
      sx={{ maxWidth: "80%" }}
    >
      <img src={lockSvg} alt="token expired svg" />
      <Typography variant="h1" color={c.brandDark64}>
        {t(PAGE_LOCALE_KEY + "title")}
      </Typography>
      <Typography variant="content-m" color={c.blackDark666}>
        {t(PAGE_LOCALE_KEY + "content")}
      </Typography>
      <ButtonMAS
        variant="auth-button"
        onClick={() => navigate("/user/login", { replace: true })}
        style={{ minHeight: "45px", width: "100%", maxWidth: "200px" }}
      >
        {t(PAGE_LOCALE_KEY + "button.back")}
      </ButtonMAS>
    </Stack>
  );
};

export default TokenExpired;
